/**
 * Test environment configuration
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://wa-gerwc-valamar-payment-rules-api-test-01-e6fqfeewdma2gfcz.germanywestcentral-01.azurewebsites.net',
  // TODO: replace with the custom domain once it's set up for this Static Web App
  hostURL: 'https://victorious-mud-0ca3b5703.5.azurestaticapps.net',
  azureAd: {
    tenantId: 'c7223f2c-1ba2-43c8-be7f-57e6e1465036',
    clientId: '4697e713-921c-4ddb-b51a-f8d0256f43ed',
    redirectUri: window.location.origin,
    authority: 'https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036',
    apiScope: 'api://69924b4b-5d9e-43a7-a7be-63a083648416/All',
    baseURL: window.location.origin
  },
  title: 'Valamar Payment Journey (Test)'
};
